export default __webpack_public_path__ + "images/Schuette_grau_Vision.webp?b6d0496419c9bdf8e18541a0e8b5a132";